/**
 * The CleanCleaver mark (docs/brand-cleancleaver-mark.svg): one ink, no stripes, a small sparkle glint knocked out of the blade.
 * The geometry is the same as apps/landing/icons-src/mark.ts (a test keeps the two equal). The mascot is the mark with a face.
 */
export const MARK_SIL = "M18 18H132V40H146V45H191Q198 45 198 52V68Q198 75 191 75H146V80H132V86Q84 94 32 104Q12 107 12 88V24Q12 18 18 18Z";
export const MARK_HOLE = "M35 34a7 7 0 1 0-14 0a7 7 0 1 0 14 0Z";
export const MARK_RIVETS = "M163.5 60a3.5 3.5 0 1 0-7 0a3.5 3.5 0 1 0 7 0ZM177.5 60a3.5 3.5 0 1 0-7 0a3.5 3.5 0 1 0 7 0ZM191.5 60a3.5 3.5 0 1 0-7 0a3.5 3.5 0 1 0 7 0Z";
export const MARK_GLINT = "M92 31Q94.66 47.34 111 50Q94.66 52.66 92 69Q89.34 52.66 73 50Q89.34 47.34 92 31ZM116 64.5Q117.05 70.95 123.5 72Q117.05 73.05 116 79.5Q114.95 73.05 108.5 72Q114.95 70.95 116 64.5Z";
/** The mascot keeps its glint high on the blade, clear of the eyes. */
const FACE_GLINT = "M117 24Q118.4 32.6 127 34Q118.4 35.4 117 44Q115.6 35.4 107 34Q115.6 32.6 117 24Z";

/** The cleaver drawing (210 × 120 units). `ink` is the one color; the hole, rivets and glint are cut out so any background shows through. */
export function Cleaver({ ink = "#17232E", face = false }: { ink?: string; face?: boolean }) {
  return <path className="cleaver-ink" fill={ink} fillRule="evenodd" d={`${MARK_SIL}${MARK_HOLE}${MARK_RIVETS}${face ? FACE_GLINT : MARK_GLINT}`} />;
}

export function CleaverMark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 210 120" className={className} {...(title ? { role: "img", "aria-label": title } : { "aria-hidden": true })}>
      <Cleaver />
    </svg>
  );
}

/** The friend for empty and success states only (UX_SCOPE: never on errors or stop states). */
export function Mascot({ className = "mascot", wink = false }: { className?: string; wink?: boolean }) {
  const eye = (cx: number, right: boolean) => (
    <g key={cx}>
      <ellipse cx={cx} cy="50" rx="9" ry="12" fill="#FBFAF6" />
      <circle cx={cx} cy="51" r="5.2" fill="#17232E" />
      <circle cx={cx + 1.8} cy="49.2" r="1.8" fill="#FBFAF6" />
      <rect className={right && wink ? "lid-r" : "blink"} x={cx - 11} y="36" width="22" height="28" rx="10" fill="#17232E" />
    </g>
  );
  return (
    <svg viewBox="0 0 210 120" className={`${className}${wink ? " mascot-wink" : ""}`} aria-hidden="true">
      <Cleaver face />
      <g>
        {eye(58, false)}
        {eye(88, true)}
        <path d="M60 72 Q73 83 86 72" fill="none" stroke="#FBFAF6" strokeWidth="3.5" strokeLinecap="round" />
        <circle cx="49" cy="70" r="4" fill="#F29A5C" opacity=".9" />
        <circle cx="97" cy="70" r="4" fill="#F29A5C" opacity=".9" />
      </g>
    </svg>
  );
}
